import { Component } from '@angular/core';
import * as Highcharts from 'highcharts';
import { OrderServiceService } from 'src/app/services/orders/order-service.service';

@Component({
  selector: 'app-chart-orders-by-category',
  templateUrl: './chart-orders-by-category.component.html',
  styleUrls: ['./chart-orders-by-category.component.scss']
})
export class ChartOrdersByCategoryComponent {
  Highcharts: typeof Highcharts = Highcharts;
  constructor(private orderService: OrderServiceService) { }

  ngOnInit() {
    this.getData();
  }

  async getData() {
    const values = [];
    this.orderService.get_data_chart_orders_by_category().then((response: any) => {
      for (let data of response.data) {
        values.push({ name: data.categoryName, y: Math.floor(data.totalAmount / 100) });
      }
    });

    await fetch('https://demo-live-data.highcharts.com/aapl-v.json').then(
      (response) => response.json()
    );

    Highcharts.chart('container-category', {
      chart: {
        type: 'pie',
      },
      accessibility: {
        point: {
          valueSuffix: '%'
        }
      },

      title: {
        text: 'Ventas por categoría',
      },

      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            format: '{point.percentage:.1f}%',
            enabled: true,
          }
        }
      },

      series: [
        {
          name: 'Total',
          type: 'pie',
          innerSize: '55%',
          data: values,
        },
      ],
    });
  }


}
